import { Outlet } from 'react-router'
import { observer } from 'mobx-react-lite'
import { ReviewsPageProvider } from 'pages/reviews/context/reviewsPageContext'

export const ReviewsPageLayout = observer(() => (
  <ReviewsPageProvider>
    <Outlet />
  </ReviewsPageProvider>
))
